import { render, staticRenderFns } from "./table-human.vue?vue&type=template&id=562da994&scoped=true"
import script from "./table-human.vue?vue&type=script&lang=js"
export * from "./table-human.vue?vue&type=script&lang=js"
import style0 from "./table-human.vue?vue&type=style&index=0&id=562da994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562da994",
  null
  
)

export default component.exports